import type { NoiseReducer, NoiseReductionProvider } from "./NoiseReducer";

/**
 * Delegates noise suppression entirely to the browser's native getUserMedia
 * constraints (noiseSuppression: true in audioConstraintStore).
 * Returns the input stream unchanged — the processing already happened at
 * capture time.
 */
export class BrowserReducer implements NoiseReducer {
    async init(): Promise<void> {
        // No initialization required; constraints are set in audioConstraintStore.
    }

    async processStream(input: MediaStream): Promise<MediaStream> {
        return input;
    }

    close(): void {
        // Nothing to release.
    }

    getProvider(): NoiseReductionProvider {
        return "browser";
    }
}
